import http from '../api/api'
import config from '../api/constants'

export function showFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.pdf`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

const getGimacProviderList = async (req) => {
  try {
    const reqParams = {
      ...req,
      requestId: 'GIMACPROVIDERLIST',
    }
    const response = await http.post(config.apiRoute.GET_GIMAC_PROVIDER_LIST, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const lastNTransaction = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'RECEIPTDOWNLOAD',
    }
    const response = await http.post(config.apiRoute.GIMAC_LAST_N_TRANSACTIONS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const downLoadReport = async (reqParams) => {
  try {
    const params = {
      requestId: 'RECEIPTDOWNLOAD',
      ...reqParams,
    }
    const downloadFile = await http.post(config.apiRoute.DOWNLOAD_GIMAC_RECEIPT, params, {
      responseType: 'arraybuffer',
    })
    showFile(downloadFile.data, reqParams.transRefNum)
    return downloadFile.data
  } catch (err) {
    throw err.response.data
  }
}

const gimacWalletVerify = async (req) => {
  try {
    const reqParams = {
      ...req,
      requestId: 'GIMACPROVIDERLIST',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.apiRoute.GIMAC_VERIFY, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const gimacWalletConfirm = async (req) => {
  try {
    const reqParams = {
      ...req,
      requestId: 'GIMACPROVIDERLIST',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.apiRoute.GIMAC_CONFIRM, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const cardlessTransactionList = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'RECEIPTDOWNLOAD',
      module: "GIMAC",
    }
    const response = await http.post(config.apiRoute.GIMAC_CARDLESS_CASH, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const cardlessDownLoadReport = async (reqParams) => {
  try {
    const params = {
      requestId: 'RECEIPTDOWNLOAD',
      module: "GIMAC",
      ...reqParams,
    }
    const downloadFile = await http.post(config.apiRoute.GIMAC_DOWNLOAD, params, {
      responseType: 'arraybuffer',
    })
    showFile(downloadFile.data, reqParams.transRefNum)
    return downloadFile.data
  } catch (err) {
    throw err.response.data
  }
}

const lastNTransactionIncoming = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'RECEIPTDOWNLOAD',
    }
    const response = await http.post(config.apiRoute.GIMAC_LAST_N_TRANSACTION_INCOMING, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const GimacService = {
  getGimacProviderList,
  lastNTransaction,
  downLoadReport,
  gimacWalletVerify,
  gimacWalletConfirm,
  cardlessTransactionList,
  cardlessDownLoadReport,
  lastNTransactionIncoming
}

export default GimacService
